import { useState, useEffect, useRef } from 'react';
import { useParams } from 'react-router-dom';
import CryptoChart from './CoindetailsChart';
import CoinMarkets from './CoinMarkets';
import RelatedCoins from './RelatedCoins';
// import TrendingCoins from './TrendingCoins';

const homeUrl = process.env.REACT_APP_HOME_URL;
const apiUrl = process.env.REACT_APP_API_URL;
let debounceTimeout: NodeJS.Timeout;

const CoinDetails = () => {
	const { coin_slug } = useParams();
	const [coinData, setCoinData] = useState([]);
	const [loading, setLoading] = useState(true);
	const [error, setError] = useState(null);
	const [articles, setArticles] = useState([]);
	const [skeletoncard, setSkeletonCard] = useState(true);

	const [exchangeLogos, setExchangeLogos] = useState(null);

	const tickers = coinData?.tickers || [];


	const aboutRef = useRef(null);
	const overviewRef = useRef(null);
	const marketRef = useRef(null);
	const newsRef = useRef(null);
	const similarRef = useRef(null);

	const headerRef = useRef(null); // attach to your header_mainsec

	const scrollToSection = (ref) => {
	  const headerEl = headerRef.current || document.querySelector('.header_mainsec');
	  const headerH = headerEl ? headerEl.offsetHeight : 0;

	  const y = ref.current.getBoundingClientRect().top + window.pageYOffset - headerH - 40; // extra padding
	  window.scrollTo({ top: y, behavior: 'smooth' });
	};

	// Extract 7d range (if available)
	// Extract 7d range (if available)
	const sparkline_7d = coinData?.market_data?.sparkline_7d?.price || [];
	const low_7d = sparkline_7d.length ? Math.min(...sparkline_7d) : null;
	const high_7d = sparkline_7d.length ? Math.max(...sparkline_7d) : null;
	// Track the current request
	const currentRequest = useRef(null);

	const fetchCoinDetails = async (signal) => {
	try {
	  setLoading(true);
	  setError(null);
	  setSkeletonCard(false);
	  
	  const request = fetch(`${apiUrl}/get-coin-details?coin_id=${coin_slug}`, { signal });
	  currentRequest.current = request;
	  
	  const response = await request;
	  
	  // Verify this is still the latest request
	  if (currentRequest.current !== request) return;
	  
	  const data = await response.json();
	  
	  setCoinData(data);
	  setLoading(false);
	} catch (err) {
	  if (err.name !== 'AbortError') {
	    setError(err.message);
	    setLoading(false);
	  }
	}
	};

	useEffect(() => {
	if (!coin_slug) return;

	const controller = new AbortController();
	fetchCoinDetails(controller.signal);

	return () => {
	  controller.abort();
	  currentRequest.current = null;
	};
	}, [coin_slug]);

	// Debugging logs (remove in production)
	useEffect(() => {
	console.log('Component rendered with:', { coin_slug, loading, data: coinData });
	});

	useEffect(() => {
	const fetchRSSfoot = async () => {
	  try {
	    const rssUrl = 'https://decrypt.co/feed';
	    const proxyUrl = `https://api.rss2json.com/v1/api.json?rss_url=${encodeURIComponent(rssUrl)}`;

	    const response = await fetch(proxyUrl);
	    const data = await response.json();    
	    setArticles(data.items);
	  } catch (err) {
	    console.error('Error fetching RSS feed:', err);
	  }
	};

	fetchRSSfoot();
	}, []);

	const formatDate = (dateString) => {
	  const date = new Date(dateString);
	  return date.toLocaleString('en-US', {
	    year: 'numeric',
	    month: 'long',
	    day: 'numeric',
	    hour: 'numeric',
	    minute: '2-digit',
	    hour12: true
	  });
	};

	useEffect(() => {
	  const fetchLogos = async () => {
	    try {
	      const res = await fetch(`${apiUrl}/get-exchanges-data`);
	      const data = await res.json();
	      const logos = {};
	      data.forEach(exchange => {
	        logos[exchange.id] = exchange.image;
	      });
	      setExchangeLogos(logos);
	    } catch (error) {
	      console.error("Failed to fetch exchange logos", error);
	    }
	  };

	  fetchLogos();
	}, []);




return (

<div className="coindetails_wrapper">
  <div className="coindetails_mainsec">
    <div className="container">
      <div className="row">
        <div className="col-sm-12 col-md-12 col-lg-12 col-xl-12">
          <div className="innerpage">
            <div className="breadcrumb_mainsec">
              <ul>
                <li><a href="#">Home</a></li>
                <li><span>{coinData.name}</span></li>
              </ul>
            </div>
            
            <div className="pageinfo_mainsec">
              <div className="row">
                <div className="col-sm-12 col-md-5 col-lg-4 col-xl-4">
                  <div className="coinprice_sidebar">
                    <div className="coin_infobox">
                      <div className="cryptoname">
                        <img 
						  alt={`${coinData?.name || ''} Logo`} 
						  src={coinData?.image?.thumb || ''} 
						/>
                        <span className="coinname">{coinData.name} <span className="cointxt">{coinData.symbol}</span></span>
                        
                      </div>
                      
                      <div className="pricebox">
                       {coinData?.market_data ? (
						  <h2>
						    ${coinData.market_data.current_price.usd.toLocaleString('en-US', { 
						        minimumFractionDigits: 2, 
						        maximumFractionDigits: 2 
						      })
						    }
						    <span 
						      className={`updown_txt ${
						        coinData.market_data.price_change_percentage_1h_in_currency?.usd >= 0 
						          ? "upcoin" 
						          : "downcoin"
						      }`}
						    >
						      {coinData.market_data.price_change_percentage_1h_in_currency?.usd >= 0 ? (
						        <i className="fas fa-caret-up"></i>
						      ) : (
						        <i className="fas fa-caret-down"></i>
						      )}
						      {coinData.market_data.price_change_percentage_1h_in_currency?.usd !== undefined && (
						        <span>
						          {Math.abs(
						            coinData.market_data.price_change_percentage_1h_in_currency.usd
						          ).toFixed(2)}%
						        </span>
						      )}
						    </span>
						  </h2>
						) : (
						  <h2>Loading...</h2>
						)}

                        
                      </div>
                    </div>
                    
                    <div className="coinmarket_info">
                      <ul>
                        <li>
                          <span className="title_txt">Market Cap</span>
                          <span>
							  {coinData?.market_data?.market_cap?.usd !== undefined
							    ? `$${coinData.market_data.market_cap.usd.toLocaleString('en-US', { 
							        minimumFractionDigits: 2, 
							        maximumFractionDigits: 2 
							      })}`
							    : "Loading..."}
							</span>
                        </li>
                         
                        <li>
						  <span className="title_txt">Fully Diluted Valuation</span>
						  <span>
						    {coinData?.market_data?.fully_diluted_valuation?.usd !== undefined
						      ? `$${coinData.market_data.fully_diluted_valuation.usd.toLocaleString('en-US', { 
						          minimumFractionDigits: 2, 
						          maximumFractionDigits: 2 
						        })}`
						      : "Loading..."}
						  </span>
						</li>

						<li>
						  <span className="title_txt">24 Hour Trading Vol</span>
						  <span>
						    {coinData?.market_data?.total_volume?.usd !== undefined
						      ? `$${coinData.market_data.total_volume.usd.toLocaleString('en-US', { 
						          minimumFractionDigits: 2, 
						          maximumFractionDigits: 2 
						        })}`
						      : "Loading..."}
						  </span>
						</li>

						<li>
						  <span className="title_txt">Circulating Supply</span>
						  <span>
						    {coinData?.market_data?.circulating_supply !== undefined
						      ? coinData.market_data.circulating_supply.toLocaleString('en-US', { 
						          minimumFractionDigits: 2, 
						          maximumFractionDigits: 2 
						        })
						      : "Loading..."}
						  </span>
						</li>

						<li>
						  <span className="title_txt">Total Supply</span>
						  <span>
						    {coinData?.market_data?.total_supply !== undefined
						      ? coinData.market_data.total_supply.toLocaleString('en-US', { 
						          minimumFractionDigits: 2, 
						          maximumFractionDigits: 2 
						        })
						      : "Loading..."}
						  </span>
						</li>

						<li>
						  <span className="title_txt">Max Supply</span>
						  <span>
						    {coinData?.market_data?.max_supply != null
						      ? coinData.market_data.max_supply.toLocaleString('en-US', { 
						          minimumFractionDigits: 2, 
						          maximumFractionDigits: 2 
						        })
						      : "NA"}
						  </span>
						</li>

                      </ul>
                    </div>
                    
                    <div className="btc_historicalprice_sec">
                      <div className="titlebox">
                        <h4>{coinData.name} Historical Price</h4>
                      </div>
                      
                      <div className="priceinfo">
                        <ul>
                          <li>
                            <span className="title_txt">24h Range</span>
                            <span>
                              {coinData?.market_data?.high_24h?.usd 
                                ? `$${coinData.market_data.high_24h.usd.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}` 
                                : 'N/A'}
                              {' – '}
                              {coinData?.market_data?.low_24h?.usd 
                                ? `$${coinData.market_data.low_24h.usd.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}` 
                                : 'N/A'}
                            </span>
                          </li>
                          
                          <li>
                            <span className="title_txt">7d Range</span>
                            <span>
                              {high_7d ? `$${high_7d.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}` : 'N/A'}
                              {' – '}
                              {low_7d ? `$${low_7d.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}` : 'N/A'}
                            </span>
                          </li>
                          
                          <li>
                            <span className="title_txt">All-Time High</span>
                            <span>
                              <h2>
                                {coinData?.market_data?.ath?.usd 
                                  ? `$${coinData.market_data.ath.usd.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}` 
                                  : 'N/A'}
                                {coinData?.market_data?.ath_change_percentage?.usd && (
                                  <span className={coinData.market_data.ath_change_percentage.usd >= 0 ? "upcoin" : "downcoin"}>
                                    {coinData.market_data.ath_change_percentage.usd >= 0 ? (
                                      <i className="fas fa-caret-up"></i>
                                    ) : (
                                      <i className="fas fa-caret-down"></i>
                                    )}
                                    {Math.abs(coinData.market_data.ath_change_percentage.usd).toFixed(2)}%
                                  </span>
                                )}
                              </h2>
                              <p>
                                {coinData?.market_data?.ath_date?.usd 
                                  ? new Date(coinData.market_data.ath_date.usd).toLocaleDateString() 
                                  : 'Date not available'}
                              </p> 
                            </span>
                          </li>
                          
                          <li>
                            <span className="title_txt">All-Time Low</span>
                            <span>
                              <h2>
                                {coinData?.market_data?.atl?.usd 
                                  ? `$${coinData.market_data.atl.usd.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}` 
                                  : 'N/A'}
                                {coinData?.market_data?.atl_change_percentage?.usd && (
                                  <span className={coinData.market_data.atl_change_percentage.usd >= 0 ? "upcoin" : "downcoin"}>
                                    {coinData.market_data.atl_change_percentage.usd >= 0 ? (
                                      <i className="fas fa-caret-up"></i>
                                    ) : (
                                      <i className="fas fa-caret-down"></i>
                                    )}
                                    {Math.abs(coinData.market_data.atl_change_percentage.usd).toFixed(2)}%
                                  </span>
                                )}
                              </h2>
                              <p>
                                {coinData?.market_data?.atl_date?.usd 
                                  ? new Date(coinData.market_data.atl_date.usd).toLocaleDateString() 
                                  : 'Date not available'}
                              </p>
                            </span>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
                
                <div className="col-sm-12 col-md-7 col-lg-8 col-xl-8">
                  <div className="tabbtn_mainsec">
                    <ul>

                      <li className="active"><a onClick={() => scrollToSection(overviewRef)}>Overview</a></li>
						          <li><a onClick={() => scrollToSection(aboutRef)}>About</a></li>
						          <li><a onClick={() => scrollToSection(marketRef)}>{coinData.name} Markets</a></li>
						          <li><a onClick={() => scrollToSection(newsRef)}>News</a></li>
						          <li><a onClick={() => scrollToSection(similarRef)}>Similar Coins</a></li>
                    </ul>
                  </div>
                  
                  <div className="price_overview" ref={overviewRef}>
                    <CryptoChart coinId={coin_slug} />
                  </div>
                  
                  <div className="coinprice_change">
                    <div className="table-responsive">
                      <table className="table">
                        <thead>
                          <tr>
                            <th scope="col">1h</th>
                            <th scope="col">24h</th>
                            <th scope="col">7d</th>
                            <th scope="col">14d</th>
                            <th scope="col">30d</th>
                            <th scope="col">1y</th>
                          </tr>
                        </thead>
                        
                        <tbody>
                          <tr>
                            <td>
                              {coinData?.market_data && (
								  <span
								    className={
								      coinData.market_data.price_change_percentage_1h_in_currency.usd < 0
								        ? "downcoin"
								        : "upcoin"
								    }
								  >
								    {coinData.market_data.price_change_percentage_1h_in_currency.usd < 0 ? (
								      <i className="fas fa-caret-down"></i>
								    ) : (
								      <i className="fas fa-caret-up"></i>
								    )}
								    {Math.abs(
								      coinData.market_data.price_change_percentage_1h_in_currency.usd
								    ).toFixed(2)}%
								  </span>
								)}

                            </td>
                            <td>
                              {coinData?.market_data && (
								  <span
								    className={
								      coinData.market_data.price_change_percentage_24h_in_currency.usd < 0
								        ? "downcoin"
								        : "upcoin"
								    }
								  >
								    {coinData.market_data.price_change_percentage_24h_in_currency.usd < 0 ? (
								      <i className="fas fa-caret-down"></i>
								    ) : (
								      <i className="fas fa-caret-up"></i>
								    )}
								    {Math.abs(
								      coinData.market_data.price_change_percentage_24h_in_currency.usd
								    ).toFixed(2)}%
								  </span>
								)}

                            </td>
                            <td>
                              {coinData?.market_data && (
								  <span
								    className={
								      coinData.market_data.price_change_percentage_7d_in_currency.usd < 0
								        ? "downcoin"
								        : "upcoin"
								    }
								  >
								    {coinData.market_data.price_change_percentage_7d_in_currency.usd < 0 ? (
								      <i className="fas fa-caret-down"></i>
								    ) : (
								      <i className="fas fa-caret-up"></i>
								    )}
								    {Math.abs(
								      coinData.market_data.price_change_percentage_7d_in_currency.usd
								    ).toFixed(2)}%
								  </span>
								)}

                            </td>
                            <td>
                              {coinData?.market_data && (
								  <span
								    className={
								      coinData.market_data.price_change_percentage_14d_in_currency.usd < 0
								        ? "downcoin"
								        : "upcoin"
								    }
								  >
								    {coinData.market_data.price_change_percentage_14d_in_currency.usd < 0 ? (
								      <i className="fas fa-caret-down"></i>
								    ) : (
								      <i className="fas fa-caret-up"></i>
								    )}
								    {Math.abs(
								      coinData.market_data.price_change_percentage_14d_in_currency.usd
								    ).toFixed(2)}%
								  </span>
								)}

                            </td>
                            <td>
                              {coinData?.market_data && (
								  <span
								    className={
								      coinData.market_data.price_change_percentage_30d_in_currency.usd < 0
								        ? "downcoin"
								        : "upcoin"
								    }
								  >
								    {coinData.market_data.price_change_percentage_30d_in_currency.usd < 0 ? (
								      <i className="fas fa-caret-down"></i>
								    ) : (
								      <i className="fas fa-caret-up"></i>
								    )}
								    {Math.abs(
								      coinData.market_data.price_change_percentage_30d_in_currency.usd
								    ).toFixed(2)}%
								  </span>
								)}

                            </td>
                            <td>
                              {coinData?.market_data && (
								  <span
								    className={
								      coinData.market_data.price_change_percentage_1y_in_currency.usd < 0
								        ? "downcoin"
								        : "upcoin"
								    }
								  >
								    {coinData.market_data.price_change_percentage_1y_in_currency.usd < 0 ? (
								      <i className="fas fa-caret-down"></i>
								    ) : (
								      <i className="fas fa-caret-up"></i>
								    )}
								    {Math.abs(
								      coinData.market_data.price_change_percentage_1y_in_currency.usd
								    ).toFixed(2)}%
								  </span>
								)}

                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                  
                  <div className="about_mainsec" ref={aboutRef}>
                    <div className="contntbox">
                      <h3>About {coinData.name} ({coinData.symbol})</h3>
                      
                      <h4>Who created {coinData.name}?</h4>
                      
                      <p>{coinData.description?.en || 'No description available'}</p>
                      
                      
                    </div>
                  </div>
                </div>
              </div>
              
              <div className="row">
                <div className="col-sm-12 col-md-12 col-lg-12 col-xl-12">
                  <div className="bitcoin_markets_info" ref={marketRef}>
                    <div className="titlebox">
                      <h4>{coinData.name} Markets</h4>
                      <p className="disclosure">Affiliate disclosures</p>
                    </div>

                    <CoinMarkets 
                      tickers={coinData?.tickers || []} exchangeLogos={exchangeLogos}
                      homeUrl={homeUrl} 
                    />

                  </div>
                  
                  <div className="articals_mainsec" ref={newsRef}>
                    <div className="row">
                      <div className="col-sm-12 col-md-12 col-lg-12 col-xl-12">
                        <div className="title_mainsec">
                          <h2>Latest News</h2>
                        </div>
                      </div>
                    </div>
                    
                    <div className="row" >
                      {articles && articles.slice(0, 3).map((item, index) => (  
                      <div className="col-sm-12 col-md-4 col-lg-4 col-xl-4">
                        <div className="articals_mainbox">
                          <div className="articals_imgbox">
                            <img alt={item.title} src={item.enclosure.link} />
                          </div>
                          
                          <div className="articals_contntbox">
                            <div className="artical_info">
                             	<div class="datetimebox" bis_skin_checked="1">
									<span class="datetime">
									<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-calendar h-3 w-3">
									<path d="M8 2v4"></path><path d="M16 2v4"></path>
									<rect width="18" height="18" x="3" y="4" rx="2"></rect>
									<path d="M3 10h18"></path></svg>
									<span class="datetxt">{formatDate(item.pubDate)}
									</span>
									</span>
								</div>
                            </div>
                            
                            <div className="artical_contnt">
                              <h3><a href={`${homeUrl}artical/${item.title.replace(/[^a-zA-Z0-9 ]/g, '')}?source=Decrypt`}>{item.title}</a></h3>
                              <p className="article_description" dangerouslySetInnerHTML={{ __html: item.description }}></p>
                            </div>
                          </div>
                        </div>
                      </div>
                      ))}
                    </div>
                  </div>
                  {/*
                  <div className="articals_mainsec blog_mainsec">
                    <div className="row">
                      <div className="col-sm-12 col-md-12 col-lg-12 col-xl-12">
                        <div className="title_mainsec">
                          <h2>Latest Blogs</h2>
                        </div>
                      </div>
                    </div>
                    
                    <div className="row">
                      <div className="col-sm-12 col-md-4 col-lg-4 col-xl-4">
                        <div className="articals_mainbox">
                          <div className="articals_imgbox">
                            <img alt="Crypto News Image" src={`${homeUrl}/assets/img/crypto-news-imge04.jpg`} />
                          </div>
                          
                          <div className="articals_contntbox">
                            <div className="artical_info">
                              <span className="author_name">Admin</span>
                              <span className="time_txt">3 mins ago</span>
                            </div>
                            
                            <div className="artical_contnt">
                              <h3><a href="/artical-details">What is Lorem Ipsum</a></h3>
                              <p>Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s.</p>
                            </div>
                          </div>
                        </div>
                      </div>
                      
                      <div className="col-sm-12 col-md-4 col-lg-4 col-xl-4">
                        <div className="articals_mainbox">
                          <div className="articals_imgbox">
                            <img alt="Crypto News Image" src={`${homeUrl}/assets/img/crypto-news-imge05.jpg`} />
                          </div>
                          
                          <div className="articals_contntbox">
                            <div className="artical_info">
                              <span className="author_name">Admin</span>
                              <span className="time_txt">April 20, 2025</span>
                            </div>
                            
                            <div className="artical_contnt">
                              <h3><a href="/artical-details">What is Lorem Ipsum</a></h3>
                              <p>Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s.</p>
                            </div>
                          </div>
                        </div>
                      </div>
                      
                      <div className="col-sm-12 col-md-4 col-lg-4 col-xl-4">
                        <div className="articals_mainbox">
                          <div className="articals_imgbox">
                            <img alt="Crypto News Image" src={`${homeUrl}/assets/img/crypto-news-imge06.jpg`} />
                          </div>
                          
                          <div className="articals_contntbox">
                            <div className="artical_info">
                              <span className="author_name">Admin</span>
                              <span className="time_txt">April 8, 2025</span>
                            </div>
                            
                            <div className="artical_contnt">
                              <h3><a href="/artical-details">What is Lorem Ipsum</a></h3>
                              <p>Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s.</p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  */}
                  <div ref={similarRef}>
                  	<RelatedCoins coinId={coin_slug} homeUrl={homeUrl} />
                  </div>

                 {/* <TrendingCoins homeUrl={homeUrl} /> */}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
 
</div>

);
};

export default CoinDetails;